import React from 'react'
import ReactECharts from 'echarts-for-react';
import axios from 'axios';
import { osintRequestAddress} from '../../config'

const Trends = (props) => {
    const trendsOption = () => {
        var options = {
            grid: { top: 8, right: 8, bottom: 24, left: 36 },
            xAxis: {
                type: 'category',
            },
            yAxis: {
                type: 'value',
            },
            series: [
                {
                    type: 'line',
                    smooth: true,
                },
            ],
            tooltip: {
                trigger: 'axis',
            },
        };
        if (props.trendsData) {
            options.xAxis.data = props.trendsData.keys
            options.series[0].data = props.trendsData.values
        }
        return options;
    }

    const onTrendClick = (param) => {
        if (param.name) {
            axios.get(`${osintRequestAddress}/tw?wordfreqrange=1&screenName=${props.screenName}&date=${param.name.replace("/",".")}`).then(
                response => {
                    if (response.data) {
                        props.setTweetsList(`发贴于${param.name.replace(".","月")}日的推文：`, response.data)
                    }
                },
                error => { console.log("error", error) }
            )
        }
    }

    return props.trendsData ? <ReactECharts option={trendsOption()} onEvents={{'click': onTrendClick}}/>:''
}

export default Trends;
